(function() {
    'use strict';

    angular
        .module('alpha.utils.recordData', [
            'alpha.utils.I18n'
        ])
        .factory('RecordDataUtil', RecordDataUtil)
        .filter('displayValue', DisplayValueFilter)
        .constant({
            DATE_FIELD_FORMAT: 'MM/DD/YYYY',
            TIME_FIELD_FORMAT: 'DD-MMM-YYYY HH:mm:ss',
            DATE_TIME_FIELD_FORMAT: 'DD-MMM-YYYY HH:mm:ss',
            DATE_TERM_FORMAT: 'DD-MMM-YYYY',
            DEFAULT_NUMBER_PRECISION: 2,
            MAX_NUMBER_PRECISION: 15,
            DEFAULT_CURRENCY_PRECISION: 2,
            MAX_CURRENCY_PRECISION: 15,
            AGGREGATE_DATA_TYPES: ['String', 'Number', 'Currency', 'SummarizedNumber', 'SummarizedCurrency', 'Date', 'LookupLibrary'],
            NUMERIC_DATA_TYPES: ['Number', 'Currency', 'SummarizedNumber', 'SummarizedCurrency'],
            FORMULA_DATA_TYPES: ['String', 'Number', 'Currency', 'Date'],
            REPORTABLE_DATA_TYPES: ['String', 'Number', 'Currency', 'Date', 'SummarizedNumber', 'SummarizedCurrency', 'LookupLibrary'],
            EMAIL_REGEX: '^(?=.{1,64}@)(([^@<>()\\.,:\\s"]+(\\.[^@<>()\\.,:\\s"]+)*)|(".+"))@[^\\.](?=.{1,255}$)(?!.*\\.\\.)([^@]+)[^\\.]$',
            HTML_ESP_MAP : {"nbsp":" ","iexcl":"¡","cent":"¢","pound":"£","curren":"¤","yen":"¥","brvbar":"¦","sect":"§","uml":"¨","copy":"©","ordf":"ª","laquo":"«","not":"¬","reg":"®","macr":"¯","deg":"°","plusmn":"±","sup2":"²","sup3":"³","acute":"´","micro":"µ","para":"¶","middot":"·","cedil":"¸","sup1":"¹","ordm":"º","raquo":"»","frac14":"¼","frac12":"½","frac34":"¾","iquest":"¿","Agrave":"À","Aacute":"Á","Acirc":"Â","Atilde":"Ã","Auml":"Ä","Aring":"Å","AElig":"Æ","Ccedil":"Ç","Egrave":"È","Eacute":"É","Ecirc":"Ê","Euml":"Ë","Igrave":"Ì","Iacute":"Í","Icirc":"Î","Iuml":"Ï","ETH":"Ð","Ntilde":"Ñ","Ograve":"Ò","Oacute":"Ó","Ocirc":"Ô","Otilde":"Õ","Ouml":"Ö","times":"×","Oslash":"Ø","Ugrave":"Ù","Uacute":"Ú","Ucirc":"Û","Uuml":"Ü","Yacute":"Ý","THORN":"Þ","szlig":"ß","agrave":"à","aacute":"á","acirc":"â","atilde":"ã","auml":"ä","aring":"å","aelig":"æ","ccedil":"ç","egrave":"è","eacute":"é","ecirc":"ê","euml":"ë","igrave":"ì","iacute":"í","icirc":"î","iuml":"ï","eth":"ð","ntilde":"ñ","ograve":"ò","oacute":"ó","ocirc":"ô","otilde":"õ","ouml":"ö","divide":"÷","oslash":"ø","ugrave":"ù","uacute":"ú","ucirc":"û","uuml":"ü","yacute":"ý","thorn":"þ","yuml":"ÿ","fnof":"ƒ","Alpha":"Α","Beta":"Β","Gamma":"Γ","Delta":"Δ","Epsilon":"Ε","Zeta":"Ζ","Eta":"Η","Theta":"Θ","Iota":"Ι","Kappa":"Κ","Lambda":"Λ","Mu":"Μ","Nu":"Ν","Xi":"Ξ","Omicron":"Ο","Pi":"Π","Rho":"Ρ","Sigma":"Σ","Tau":"Τ","Upsilon":"Υ","Phi":"Φ","Chi":"Χ","Psi":"Ψ","Omega":"Ω","alpha":"α","beta":"β","gamma":"γ","delta":"δ","epsilon":"ε","zeta":"ζ","eta":"η","theta":"θ","iota":"ι","kappa":"κ","lambda":"λ","mu":"μ","nu":"ν","xi":"ξ","omicron":"ο","pi":"π","rho":"ρ","sigmaf":"ς","sigma":"σ","tau":"τ","upsilon":"υ","phi":"φ","chi":"χ","psi":"ψ","omega":"ω","thetasym":"ϑ","upsih":"ϒ","piv":"ϖ","bull":"•","hellip":"…","prime":"′","Prime":"″","oline":"‾","frasl":"⁄","weierp":"℘","image":"ℑ","real":"ℜ","trade":"™","alefsym":"ℵ","larr":"←","uarr":"↑","rarr":"→","darr":"↓","harr":"↔","crarr":"↵","lArr":"⇐","uArr":"⇑","rArr":"⇒","dArr":"⇓","hArr":"⇔","forall":"∀","part":"∂","exist":"∃","empty":"∅","nabla":"∇","isin":"∈","notin":"∉","ni":"∋","prod":"∏","sum":"∑","minus":"−","lowast":"∗","radic":"√","prop":"∝","infin":"∞","ang":"∠","and":"∧","or":"∨","cap":"∩","cup":"∪","int":"∫","there4":"∴","sim":"∼","cong":"≅","asymp":"≈","ne":"≠","equiv":"≡","le":"≤","ge":"≥","sub":"⊂","sup":"⊃","nsub":"⊄","sube":"⊆","supe":"⊇","oplus":"⊕","otimes":"⊗","perp":"⊥","sdot":"⋅","lceil":"⌈","rceil":"⌉","lfloor":"⌊","rfloor":"⌋","lang":"〈","rang":"〉","loz":"◊","spades":"♠","clubs":"♣","hearts":"♥","diams":"♦","\"":"quot","amp":"&","lt":"<","gt":">","OElig":"Œ","oelig":"œ","Scaron":"Š","scaron":"š","Yuml":"Ÿ","circ":"ˆ","tilde":"˜","ndash":"–","mdash":"—","lsquo":"‘","rsquo":"’","sbquo":"‚","ldquo":"“","rdquo":"”","bdquo":"„","dagger":"†","Dagger":"‡","permil":"‰","lsaquo":"‹","rsaquo":"›","euro":"€"}
        });

    RecordDataUtil.$inject = [
        'I18nUtil',
        '$filter',
        '$locale',
        '$cookies',
        'DATE_FIELD_FORMAT',
        'TIME_FIELD_FORMAT',
        'DATE_TIME_FIELD_FORMAT',
        'DATE_TERM_FORMAT',
        'DEFAULT_NUMBER_PRECISION',
        'DEFAULT_CURRENCY_PRECISION',
        'HTML_ESP_MAP'
    ];

    function RecordDataUtil(
        I18nUtil,
        $filter,
        $locale,
        $cookies,
        DATE_FIELD_FORMAT,
        TIME_FIELD_FORMAT,
        DATE_TIME_FIELD_FORMAT,
        DATE_TERM_FORMAT,
        DEFAULT_NUMBER_PRECISION,
        DEFAULT_CURRENCY_PRECISION,
        HTML_ESP_MAP
    ) {
        var HTML_ESP_MAP_EXP = new RegExp("&("+Object.keys(HTML_ESP_MAP).join("|")+");","g");

        function _getDisplayValueForNumber(n, showGroupSeparator, decimalPrecision) {
            var localizedValue;
            if (_.isFinite(decimalPrecision)) {
                localizedValue = $filter('number')(n, decimalPrecision);
            } else {
                localizedValue = _.chain($filter('number')(n, DEFAULT_NUMBER_PRECISION)).trimEnd('0').trimEnd($locale.NUMBER_FORMATS.DECIMAL_SEP).value();
            }
            return showGroupSeparator ? localizedValue : _stripGroupSeparator(localizedValue);
        }
        function _getDisplayValueForCurrency(amount, symbol, showGroupSeparator, decimalPrecision) {
            var localizedValue = $filter('currency')(amount, symbol, _.isFinite(decimalPrecision) ? decimalPrecision : DEFAULT_CURRENCY_PRECISION);
            return showGroupSeparator ? localizedValue : _stripGroupSeparator(localizedValue);
        }
        function _stripGroupSeparator(localizedValue) {
            /*
             * TODO: This function mimics a simple regular expression:
             *
             * replace(new RegExp('([0-9])[' + $locale.NUMBER_FORMATS.GROUP_SEP + ']([0-9])', 'g'), '$1$2')
             *
             * This should be replaced with the above code whenever we stop
             * supporting IE11. GROUP_SEP can fall outside the ASCII range
             * and we cannot put non-ASCII characters in a regular expression
             * because IE11 is not ES6 compliant.
             *
             * We cannot simply replace every instance of GROUP_SEP because
             * it may have other uses such as separating a currency symbol.
             */
            var arr = localizedValue.split('');
            return _.reject(arr, function(char, i) {
                var prev = arr[i - 1] || '',
                    next = arr[i + 1] || '';
                return char === $locale.NUMBER_FORMATS.GROUP_SEP && prev.match(/[0-9]/) && next.match(/[0-9]/);
            }).join('');
        }

        return {
            getDisplayValue: getDisplayValue,
            getDisplayValueForField: getDisplayValueForField,
            getNumericValue: getNumericValue,
            getNumericValueFromDisplayValue: getNumericValueFromDisplayValue,
            getSortableValue: getSortableValue,
            getTermValueFromFieldValue: getTermValueFromFieldValue,
            getFieldValueFromTermValue: getFieldValueFromTermValue,
            getDescriptionFromText: getDescriptionFromText,
            sortRecords: sortRecords,
            isRightAligned: isRightAligned,
            forEachNestedRecord: forEachNestedRecord,
            getRecordDetailUrl: getRecordDetailUrl,
            getNumericValueForCSV:getNumericValueForCSV,
            isCenterAligned:isCenterAligned,
            getNumberFormatStr: getNumberFormatStr,
            redactValue: redactValue
        };

        function getNumberFormatStr() {
            var reverseString = function (str) { return str.split("").reverse().join(""); };
            var defaultUiLocale =  I18nUtil.getLocale();
            var numberFormatStr = reverseString(new Intl.NumberFormat(defaultUiLocale).format(123456.789).replace(/[0-9]/g, ''));
            return numberFormatStr;
        }


        /**
         * Accepts a field value and returns a string for display.
         *
         * @method getDisplayValue
         *
         * @param {*} value The raw value of the field
         * @param {String} dataType The data type of the field; should match its _fieldType.dataType
         * @param {String} [widgetType] The widget type of the field; should match its _fieldType.widgetType
         * @param {Object} [fieldType] The entire field type of the field; use when additional information is needed
         * @param {Number} [fieldType.decimalPrecision] Number of decimal places to round to when displaying numeric values
         * @param {Boolean} [fieldType.decimalPrecisionEnabled] Whether to use the decimal precision setting when displaying numeric values
         * @param {Boolean} [fieldType.showGroupSeparator] Whether to show a group separator when displaying numeric values
         *
         * @returns {String} A string equivalent to be displayed in the UI
         */
        function getDisplayValue(value, dataType, widgetType, fieldType) {
            fieldType = fieldType || {};
            switch (dataType) {
                case 'String':
                    switch (widgetType) {
                        case 'DocumentLink':
                            return _getDocumentLinkValue() || '';
                        default:
                            return _getStringValue() || '';
                    }
                case 'LargeTextField':
                    return _getStringValue() || '';
                case 'Description':
                    return _getDescriptionValue() || '';
                case 'Date':
                    switch (widgetType) {
                        case 'DateTime':
                            return _getDateTimeValue() || '';
                        case 'Time':
                            return _getTimeValue() || '';
                        default:
                            return _getDateValue() || '';
                    }
                case 'LookupLibrary':
                    return _getLookupValue() || '';
                case 'Number':
                    return _getNumberValue() || '';
                case 'Currency':
                    return _getCurrencyValue() || '';
                case 'SummarizedNumber':
                    return _getSummarizedNumberValue() || '';
                case 'SummarizedCurrency':
                    return _getSummarizedCurrencyValue() || '';
                case 'Attachment':
                    return _getAttachmentValue() || '';
                case 'Location':
                    return _getLocationValue() || '';
                default:
                    return _getLookupValue() || null;
            }
            function _getStringValue() {
                if (_.isString(value)) {
                    return _htmlDecode(_stripHtml(value));
                }
            }
            function _getDescriptionValue() {
                if (_.isObject(value)) {
                    return value[I18nUtil.getLanguage()] || value.en_US || '';
                } else if (_.isString(value)) {
                    return value;
                }
            }
            function _getDateValue() {
                if (_.isNumber(value)) {
                    return $filter('date')(value + new Date(value).getTimezoneOffset() * 60000, 'shortDate');
                } else if (_.isString(value) && !_.isEmpty(value)) {
                    return $filter('date')(moment(value, [DATE_FIELD_FORMAT, 'x'], 'en-US').valueOf(), 'shortDate');
                }
            }
            function _getTimeValue() {
                if (_.isNumber(value)) {
                    return $filter('date')(value, 'shortTime');
                } else if (_.isString(value) && !_.isEmpty(value)) {
                    return $filter('date')(moment(value, [TIME_FIELD_FORMAT, 'x'], 'en-US').valueOf(), 'shortTime');
                }
            }
            function _getDateTimeValue() {
                if (_.isNumber(value)) {
                    return $filter('date')(value, 'short');
                } else if (_.isString(value) && !_.isEmpty(value)) {
                    return $filter('date')(moment(value, [DATE_TIME_FIELD_FORMAT, 'x'], 'en-US').valueOf(), 'short');
                }
            }
            function _getLookupValue() {
                if (_.isObject(value)) {
                    return value.value || value.id;
                } else if (_.isString(value)) {
                    return value;
                }
            }
            function _getNumberValue() {
                if (_.isNumber(value)) {
                    return _getDisplayValueForNumber(
                        value,
                        fieldType.showGroupSeparator !== false,
                        fieldType.decimalPrecisionEnabled ? fieldType.decimalPrecision : null
                    );
                }
            }
            function _getCurrencyValue() {
                if (_.isObject(value)) {
                    return _getDisplayValueForCurrency(
                        value.amount,
                        value.baseCurrencySymbol || '',
                        fieldType.showGroupSeparator !== false,
                        fieldType.decimalPrecisionEnabled ? fieldType.decimalPrecision : null
                    );
                } else if (_.isNumber(value)) {
                    return _getDisplayValueForNumber(
                        value,
                        fieldType.showGroupSeparator !== false,
                        fieldType.decimalPrecisionEnabled ? fieldType.decimalPrecision : null
                    );
                }
            }
            function _getSummarizedNumberValue() {
                if (_.isObject(value)) {
                    return _getDisplayValueForNumber(
                        _sum(value.total, value.deltaAmount),
                        fieldType.showGroupSeparator !== false,
                        fieldType.decimalPrecisionEnabled ? fieldType.decimalPrecision : null
                    );
                }
            }
            function _getSummarizedCurrencyValue() {
                if (_.isObject(value)) {
                    return _getDisplayValueForCurrency(
                        _sum(value.total, value.deltaAmount),
                        value.baseCurrencySymbol || '',
                        fieldType.showGroupSeparator !== false,
                        fieldType.decimalPrecisionEnabled ? fieldType.decimalPrecision : null
                    );
                }
            }

            /* return true if the variable is encoded else false */
            function containsEncodedComponents(x) {
                // ie ?,=,&,/ etc
                try {
                    return ((x !== decodeURIComponent(x)) || (decodeURI(x) !== decodeURIComponent(x)));
                }
                catch(x) {
                    return false;
                }
            }

            function _getAttachmentValue() {
                if (_.isArray(value)) {
                    var fileName = '';
                    _.forEach(value, function(file) {
                        if (containsEncodedComponents(file.fileName)) {
                            fileName = fileName + "   " +  decodeURI(file.fileName);
                        }
                        else {
                            fileName = fileName + "   " + file.fileName;
                        }
                    });
                    return  fileName;
                }
            }

            function _getLocationValue() {
                if (_.isString(value)) {
                    return _stripHtml(value);
                } else if (_.isObject(value)) {
                    return value.latitude + ',' + value.longitude;
                }
            }
            function _getDocumentLinkValue() {
                return _.chain(value).split('/').last().value();
            }
        }
        /**
         * Accepts a field value and field type and returns a string for display.
         * This is just a less verbose pass-through to getDisplayValue to be used
         * in implementations where field types are dynamic.
         *
         * @method getDisplayValueForField
         *
         * @param {*} value The raw value of the field
         * @param {Object} fieldType The field type of the field; should include all information needed for display
         * @param {String} fieldType.dataType The data type of the field
         * @param {String} [fieldType.widgetType] The widget type of the field
         * @param {String} applyRedaction if true the value is displayed as ****
         *
         * @returns {String} A string equivalent to be displayed in the UI
         */
        function getDisplayValueForField(value, fieldType, applyRedaction) {
            var result;
            if(applyRedaction && (applyRedaction === true || applyRedaction === 'true')){
                var displayValue = this.getDisplayValue(value, fieldType.dataType, fieldType.widgetType, fieldType);
                result = redactValue(displayValue,fieldType.widgetType);
            } else if(applyRedaction === null && value){
                result = '...'; // Field level security info is not yet loaded. Let us wait.
            }else {
                result = this.getDisplayValue(value, fieldType.dataType, fieldType.widgetType, fieldType);
            }
            return result;
        }

        function redactValue(input,widgetType){
            if(!input){
                return input; //If input is null or undefined, return the same.
            }
            if (widgetType === 'Email') {
                var redactedEmails;
                var emails = input.split(',');
                redactedEmails = emails.map(function (email) {
                    return email ? '******' : email;
                });
                redactedEmails = redactedEmails.join(',');
                return redactedEmails;
            }
            return '******';
        }
        /**
         * Accepts a field value and returns a numeric equivalent for calculations
         *
         * @method getNumericValue
         *
         * @param {*} value The raw value of the field
         * @param {String} dataType The data type of the field; should match its _fieldType.dataType
         *
         * @returns {Number} A number equivalent to be used for calculations
         */
        function getNumericValue(value, dataType) {
            switch (dataType) {
                case 'Number':
                    return _.isNumber(value) ? value : null;
                case 'Date':
                    return _.isNumber(value) ? value : null;
                case 'Currency':
                    return _.isObject(value) ? value.amount : (_.isNumber(value) ? value : null);
                case 'SummarizedNumber':
                case 'SummarizedCurrency':
                    return _.isObject(value) ? _sum(value.total, value.deltaAmount) : null;
            }
            return null;
        }

        function getNumericValueForCSV(value, dataType,widgetType, fieldType) {
            switch (dataType) {
                case 'Number':
                    return _.isNumber(value) ? _getDisplayValueForNumber(value, false, fieldType.decimalPrecisionEnabled ? fieldType.decimalPrecision : null) : null;
                case 'Currency':
                    return _.isObject(value) ? _getDisplayValueForCurrency(value.amount,'', false,fieldType.decimalPrecisionEnabled ? fieldType.decimalPrecision : null) : null;
                case 'SummarizedCurrency':
                case 'SummarizedNumber':
                    return _.isObject(value) ? _getDisplayValueForNumber(_sum(value.total, value.deltaAmount), false, fieldType.decimalPrecisionEnabled ? fieldType.decimalPrecision : null) : null;
            }
            return null;
        }
        /**
         * Accepts the display value of a number or currency field and returns the
         * numeric equivalent based on the current locale. All irrelevant characters
         * are ignored. Values can be negative or positive.
         *
         * @method getNumericValueFromDisplayValue
         *
         * @param {String} displayValue Display value shown in the view or entered by a user
         *
         * @returns {Number} A number equivalent to be used for calculations or building model values
         */
        function getNumericValueFromDisplayValue(displayValue) {
            var negativePatterns = $locale.NUMBER_FORMATS.PATTERNS,
                decimalSeparator = $locale.NUMBER_FORMATS.DECIMAL_SEP,
                normalizedString = decimalSeparator === '.' ? displayValue : displayValue.replace(/[.]/g, ''),
                absoluteValue = parseFloat(normalizedString.split(decimalSeparator).join('.').replace(/[^0-9.]/g, ''));
            if (_.isFinite(absoluteValue)) {
                return _isNegative() ? absoluteValue * -1 : absoluteValue;
            }
            function _isNegative() {
                var negative = false;
                _.forEach(negativePatterns, function(pattern) {
                    if ((pattern.negPre.length || pattern.negSuf.length) && _.startsWith(displayValue, pattern.negPre) && _.endsWith(displayValue, pattern.negSuf)) {
                        negative = true;
                        return false;
                    }
                });
                return negative;
            }
        }
        /**
         * Provides a value that can be used for sorting.
         *
         * @method getSortableValue
         *
         * @param {*} value The raw value of the field
         * @param {String} dataType The data type of the field; should match its _fieldType.dataType
         * @param {String} [widgetType] The widget type of the field; should match its _fieldType.widgetType
         *
         * @returns {*} A value that can be used for sorting
         */
        function getSortableValue(value, dataType, widgetType) {
            switch (dataType) {
                case 'Currency':
                    return _.isObject(value) ? value.amount : null;
                case 'Date':
                    switch (widgetType) {
                        case 'Date':
                            return _.isString(value) ? moment(value, [DATE_FIELD_FORMAT, 'x'], 'en-US').valueOf() : value;
                        case 'Time':
                            return _.isString(value) ? moment(value, [TIME_FIELD_FORMAT, 'x'], 'en-US').valueOf() : value;
                        default:
                            return _.isString(value) ? moment(value, [DATE_TIME_FIELD_FORMAT, 'x'], 'en-US').valueOf() : value;
                    }
                case 'SummarizedNumber':
                case 'SummarizedCurrency':
                    return _.isObject(value) ? _sum(value.total, value.deltaAmount) : null;
                case 'LookupLibrary':
                    return _.isObject(value) ? value.value : null;
            }
            return value;
        }
        /**
         * Accepts a field value and returns an equivalent term value for
         * filtering searches through the API.
         *
         * @method getTermValueFromFieldValue
         *
         * @param {*} value The raw value of the field
         * @param {String} dataType The data type of the field; should match its _fieldType.dataType
         *
         * @returns {Number} An equivalent to be used for filtering
         */
        function getTermValueFromFieldValue(value, dataType) {
            switch (dataType) {
                case 'String':
                case 'Attachment':
                case 'LargeTextField':
                case 'LargeText':
                case 'CurrencyType':
                case 'Location':
                    return _.isString(value) ? value : null;
                case 'Number':
                    return _.isNumber(value) ? value.toString() : null;
                case 'Date':
                    if (_.isString(value)) {
                        return moment(value, DATE_FIELD_FORMAT, 'en-US').format(DATE_TERM_FORMAT);
                    } else if (_.isNumber(value)) {
                        return moment(value).locale('en-US').utcOffset('+0000').format(DATE_TERM_FORMAT);
                    } else {
                        return null;
                    }
                case 'LookupLibrary':
                    if (_.isObject(value)) {
                        return value.id;
                    } else if (_.isString(value)) {
                        return value;
                    } else {
                        return null;
                    }
                case 'Currency':
                    if (_.isObject(value) && _.isNumber(value.amount)) {
                        return value.amount.toString();
                    } else if (_.isNumber(value)) {
                        return value.toString();
                    } else {
                        return null;
                    }
                case 'SummarizedNumber':
                case 'SummarizedCurrency':
                    if (_.isObject(value)) {
                        return _sum(value.total, value.deltaAmount).toString();
                    } else if (_.isNumber(value)) {
                        return value.toString();
                    } else {
                        return null;
                    }
            }
            return null;
        }
        /**
         * Accepts a term value and returns an equivalent field value.
         *
         * @method getFieldValueFromTermValue
         *
         * @param {*} value The raw value of the term
         * @param {String} dataType The data type of the field; should match its _fieldType.dataType
         *
         * @returns {Number} An equivalent to be used as a field value
         */
        function getFieldValueFromTermValue(value, dataType) {
            switch (dataType) {
                case 'String':
                case 'LargeTextField':
                case 'CurrencyType':
                    return _.isString(value) && value.length ? value : null;
                case 'Number':
                    return _.isNumber(value) ? value : null;
                case 'Date':
                    return _.isString(value) && value.length ? moment(value, DATE_TERM_FORMAT, 'en-US').format(DATE_FIELD_FORMAT) : null;
                case 'LookupLibrary':
                    return _.isString(value) && value.length ? {id: value, value: value} :  null;
                case 'Currency':
                    return _.isNumber(value) ? {amount: value} : null;
                case 'SummarizedNumber':
                case 'SummarizedCurrency':
                    return _.isNumber(value) ? {total: value} : null;
            }
            return null;
        }
        /**
         * Converts text into a multilingual description that meets the
         * minimum business requirements.
         *
         * @method getDescriptionFromText
         *
         * @param {String} text The text to convert
         *
         * @returns {Object|null} An equivalent multilingual description or null if there was no text
         */
        function getDescriptionFromText(text) {
            var description = {};
            _.forEach(I18nUtil.getRequiredLanguages(), function(language) {
                description[language] = text;
            });
            return _.isEmpty(text) ? null : description;
        }
        /**
         * Sorts a collection of records by a field within them. It does not modify
         * the original collection. A copy of the original collection will be returned
         * if the data type or field type is not recognized.
         *
         *
         * @method sortRecords
         *
         * @param {Object[]} records The collection of records to sort
         * @param {String} fieldType The service name of the field to sort by
         * @param {String} dataType The data type of the field; should match its _fieldType.dataType
         *
         * @returns {Object[]} A sorted collection of the same records
         */
        function sortRecords(records, fieldType, dataType) {
            switch (dataType) {
                case 'Date':
                case 'Number':
                case 'Currency':
                case 'SummarizedNumber':
                case 'SummarizedCurrency':
                    return _.sortBy(records, function(record) {
                        return getNumericValue(record[fieldType], dataType);
                    });
                case 'String':
                case 'LargeTextField':
                case 'LookupLibrary':
                case 'CurrencyType':
                    return _.sortBy(records, function(record) {
                        return getDisplayValue(record[fieldType], dataType) || null;
                    });
                default:
                    return angular.copy(records);
            }
        }
        /**
         * Returns the right alignment of the field for display
         * @param {String} dataType The data type of the field; should match its _fieldType.dataType
         * @returns {boolean}
         */
        function isRightAligned(dataType){
            return  dataType === 'Date' ||
                    dataType === 'DateTime' ||
                    dataType === 'Number' ||
                    dataType === 'SummarizedNumber' ||
                    dataType === 'Currency' ||
                    dataType === 'SummarizedCurrency';
        }
        /**
         * Deeply iterates over a provided record (or collection of records) and invokes
         * a callback for all records of a particular type that are associated to it or
         * that are associated to any of its associated records.
         *
         * Because there is no structural difference between an associated record and a
         * field that has an object value, i.e. currency, the callback may be invoked
         * for fields in some rare cases.
         *
         * @param {Object|Array} record Record to pull all instances from
         * @param {String} recordTypeId Service name of the target record type
         * @param {recordCallback} callback Callback to be invoked with each target record
         *
         * @callback recordCallback
         *
         * @param {Object} record Instance of a record of the requested type
         */
        function forEachNestedRecord(record, recordTypeId, callback) {
            var targetRecord = _.get(record, recordTypeId),
                service = this;
            if (_.isArray(targetRecord)) {
                _.forEach(targetRecord, function(targetRecordInstance) {
                    callback(targetRecordInstance);
                });
            } else if (_.isObject(targetRecord)) {
                callback(targetRecord);
            }
            if (_.isArray(record)) {
                _.forEach(record, function(recordInstance) {
                    service.forEachNestedRecord(recordInstance, recordTypeId, callback);
                });
            } else if (_.isObject(record)) {
                _.forOwn(record, function(recordInstance) {
                    service.forEachNestedRecord(recordInstance, recordTypeId, callback);
                });
            }
        }
        /**
         * Builds a URL for a record detail page based on provided criteria.
         *
         * @param {String} clientId Service name of the client
         * @param {String} recordTypeId Service name of the record type
         * @param {Number} [recordId] ID of the record
         * @param {String} [layoutId] Service name of the layout
         * @param {Object} [params] Parameters to include
         *
         * @param id
         * @returns A URL for the record detail page
         */
        function getRecordDetailUrl(clientId, recordTypeId, recordId, layoutId, params,id) {
            var url = applicationContextRoot +
                    '/record/view/view/' +
                    clientId +
                    '/' + recordTypeId;
            if (recordId) {
                _addParam(recordId, 'objId');
            }
            if (id) {
                _addParam(id, 'lookupId');
            }
            if (layoutId) {
                _addParam(layoutId, 'view');
            }
            _.forOwn(params, _addParam);
            function _addParam(value, key) {
                if (_.includes(url, '?')) {
                    url += '&' + key + '=' + value;
                } else {
                    url += '?' + key + '=' + value;
                }
            }
            return url;
        }
        /**
         * Used to strip html tags from tinymce strings so they don't show up in smarttable cells.
         *
         * @param string - Already checked if it's an actual string before this function is called.
         * @returns {string}
         * @private
         */
        function _stripHtml(string) {
            string = string.replace(/<[^>]+>/gm, '') // tags
                .replace(/&nbsp;/gm, ' ')
                .replace(/&amp;/gm, '&')
                .replace(/&gt;/gm, '>')
                .replace(/&lt;/gm, '<')
                .replace(/&quot;/gm, '"');
            return string;
        }
        /**
         * Adds two numbers together while avoiding floating point precision errors
         *
         * @param {Number} a
         * @param {Number} b
         * @returns {Number} The sum
         * @private
         */
        function _sum(a, b) {
            return math.number(math.add(math.bignumber(a || 0), math.bignumber(b || 0)));
        }
        function _htmlDecode(s){
            return s?s.replace(HTML_ESP_MAP_EXP,function(x){
                return HTML_ESP_MAP[x.substring(1,x.length-1)]||x;
            }):s;
        }
    }

    DisplayValueFilter.$inject = ['RecordDataUtil'];

    function DisplayValueFilter(RecordDataUtil) {
        return function(value, dataType, widgetType) {
            return RecordDataUtil.getDisplayValue(value, dataType, widgetType);
        };
    }

    /**
     * Returns the center alignment of the field for display
     * @param {String} dataType The data type of the field; should match its _fieldType.dataType
     * @returns {boolean}
     */
    function isCenterAligned(dataType){
        return  dataType === 'Date';
    }

})();
